import { ZoomIn } from "lucide-react";
import Image from "next/image";
import type React from "react";
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";
import { aspectRatios } from "@/constants";
import type { AspectRatio, Media } from "@/payload-types";
import { cn } from "@/utils/cn";

export const MediaDisplay: React.FC<{
	className?: string;
	ratio?: AspectRatio;
	media: Media;
}> = ({ className, media, ratio }) => {
	return (
		media && (
			<div className={className}>
				<Dialog>
					<DialogTitle className="sr-only">
						{media.caption || "Media viewer"}
					</DialogTitle>

					<DialogTrigger asChild className="w-full cursor-pointer">
						<div
							className={cn(
								"group relative overflow-hidden",
								ratio === aspectRatios.PORTRAIT && "aspect-portrait",
								ratio === aspectRatios.SQUARE && "aspect-square",
								ratio === aspectRatios.VIDEO && "aspect-video",
							)}
						>
							<Image
								alt={media.caption || "Media image"}
								blurDataURL={media.blurDataUrl ?? undefined}
								className="absolute inset-0 m-0 h-full w-full object-cover"
								height={media.height || 400}
								placeholder={media.blurDataUrl ? "blur" : "empty"}
								src={media.url || ""}
								width={media.width || 600}
							/>

							<div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-85 transition-opacity duration-700 group-hover:opacity-100 md:opacity-25">
								<ZoomIn className="h-8 w-8 text-white" />
							</div>
						</div>
					</DialogTrigger>

					<DialogContent className="h-full max-h-[95vh] max-w-7xl border-none bg-white">
						<DialogClose className="absolute top-8 right-8 z-[100] rounded-md bg-white px-4 py-2">
							Zamknij
						</DialogClose>

						<div className="relative rounded-lg">
							<Image
								alt={media.caption || "Media image"}
								blurDataURL={media.blurDataUrl ?? undefined}
								className="absolute inset-0 mx-auto aspect-video h-full w-full object-contain object-center"
								height={media.height || 400}
								placeholder={media.blurDataUrl ? "blur" : "empty"}
								src={media.url || ""}
								width={media.width || 600}
							/>

							<div className="fixed right-0 bottom-0 left-0 flex flex-col items-center justify-center">
								<p className="text-sm">{media.caption}</p>
							</div>
						</div>
					</DialogContent>
				</Dialog>
			</div>
		)
	);
};
